import clsx from "clsx";
import {
  Box,
  Container,
  makeStyles,
  Typography,
  Card,
  Button,
  FormLabel,
} from "@material-ui/core";
import Page from "src/components/Page";
import React from "react";
import KmPageTitle from "src/components/layout/KmPageTitle";
import { FileIcon, defaultStyles } from "react-file-icon";
import SvgIcon from "@material-ui/core/SvgIcon";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { apiDownloadFileData, apiEndpoints } from "src/utils/api/api";
import fileDownload from "js-file-download";

const userInstFileName = "Instrukcja uzytkownika Portalu KM.pdf";
const secPolFileName =
  "Polityka Bezpieczeństwa Przetwarzania Danych Osobowych w UMWP.docx";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
}));

const HelpView = (rest) => {
  const classes = useStyles();

  const handleFileDownload = (documentKey, fileName) => {
    apiDownloadFileData(
      `${apiEndpoints.downloadSystemDocument.path}${documentKey}`,
      true
    )
      .then((result) => {
        fileDownload(result, fileName);
      })
      .catch((error) => {});
  };

  return (
    <Page className={classes.root} title="Informacje">
      <KmPageTitle>Pliki</KmPageTitle>

      <Box mt={3}>
        <Card className={clsx(classes.root)}>
          <Box display="flex" flexDirection="column">
            <FormLabel>Dokumenty do pobrania:</FormLabel>
            <Box p={2} display="flex" flexWrap="wrap">
              <Box p={1}>
                <SvgIcon className={classes.fileicon}>
                  <FileIcon extension={"pdf"} {...defaultStyles["pdf"]} />
                </SvgIcon>
                <Typography className={classes.filename} display="inline">
                  {userInstFileName}
                </Typography>
              </Box>

              <Box ml={2} p={1}>
                <Button
                  title="Pobranie instrukcji użytkownika w formie pliku PDF"
                  aria-label="Pobranie instrukcji użytkownika w formie pliku PDF"
                  variant="contained"
                  color="default"
                  className={classes.button}
                  startIcon={<CloudDownloadIcon />}
                  onClick={() =>
                    handleFileDownload("user_instruction", userInstFileName)
                  }
                >
                  Pobierz plik
                </Button>
              </Box>
            </Box>
            <Box p={2} display="flex" flexWrap="wrap">
              <Box p={1}>
                <SvgIcon className={classes.fileicon}>
                  <FileIcon extension={"docx"} {...defaultStyles["docx"]} />
                </SvgIcon>
                <Typography className={classes.filename} display="inline">
                  {secPolFileName}
                </Typography>
              </Box>

              <Box ml={2} p={1}>
                <Button
                  title="Pobranie Polityki Bezpieczeństwa przetwarzania danych osobowych w formie pliku DOCX"
                  aria-label="Pobranie Polityki Bezpieczeństwa przetwarzania danych osobowych w formie pliku DOCX"
                  variant="contained"
                  color="default"
                  className={classes.button}
                  startIcon={<CloudDownloadIcon />}
                  onClick={() =>
                    handleFileDownload("security_policy", secPolFileName)
                  }
                >
                  Pobierz plik
                </Button>
              </Box>
            </Box>
          </Box>
        </Card>
      </Box>
    </Page>
  );
};

export default HelpView;
